import { ICheckoutTheme } from '../../../../../common/theme/ICheckoutTheme';
import { makeStyles } from '@material-ui/core/styles';

export type AccessoriesItemClasses = 'itemContainer' | 'item' | 'itemSelected';

const itemStyles = makeStyles<ICheckoutTheme, AccessoriesItemClasses>(
  ({ palette, breakpoints }) => ({
    itemContainer: {
      marginBottom: '40px',
      [breakpoints.down('lg')]: {
        maxWidth: 'unset',
      },
    },
    item: {
      border: `1px solid ${palette.grey['300']}`,
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'space-between',
      [breakpoints.down('sm')]: {
        width: 'fit-content',
      },
    },
    itemSelected: {
      borderColor: palette.primary.main,
    },
  }),
  { name: 'Checkout4_AccessoriesItem' },
);

export default itemStyles;
